import { render, staticRenderFns } from "./ModalDetailCard.vue?vue&type=template&id=69e4940a"
import script from "./ModalDetailCard.vue?vue&type=script&lang=js"
export * from "./ModalDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69e4940a')) {
      api.createRecord('69e4940a', component.options)
    } else {
      api.reload('69e4940a', component.options)
    }
    module.hot.accept("./ModalDetailCard.vue?vue&type=template&id=69e4940a", function () {
      api.rerender('69e4940a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Dashboard/components/ModalDetailCard.vue"
export default component.exports